export default __webpack_public_path__ + "static/media/visa 1.54a230a3.svg";